<template>
  <div class="app-number-input">
    <span
      v-if="prependOuter"
      class="prepend-outer"
    >
      {{ prependOuter }}
    </span>

    <div
      :class="{
        'v-input--is-focused': focused,
        'secondary--text': focused,
        'error--text': hasError
      }"
      class="v-input v-text-field v-input--has-state v-input--is-label-active v-input--is-dirty theme--light"
    >
      <div class="v-input__control">
        <div class="v-input__slot">
          <div class="v-text-field__slot">
            <label
              :class="{
                'required-field': isRequired && !hideRequired,
                'secondary--text': focused,
                'error--text': hasError
              }"
              class="v-label v-label--active theme--light"
            >
              {{ label }}
            </label>
            <money
              v-bind="config"
              :value="value"
              :class="{ 'gray--text text--lighten-1': disabled }"
              :disabled="disabled"
              @input="input"
              @blur.native="blur"
              @focus.native="focus"
              @focusout.native="focusout"
              :maxlength="maxLength"
            />
          </div>
        </div>
        <div
          v-if="currentError"
          class="v-text-field__details"
        >
          <div
            :class="{ 'error--text': hasError }"
            class="v-messages theme--light"
          >
            <div class="v-messages__wrapper">
              <div class="v-messages__message">
                {{ currentError }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span
      v-if="appendOuter"
      class="append-outer"
    >
      {{ appendOuter }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'AppNumberInput',
  props: {
    value: {
      type: [String, Number],
      default: undefined
    },
    label: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    prefix: {
      type: String,
      default: undefined
    },
    suffix: {
      type: String,
      default: undefined
    },
    decimal: {
      type: String,
      default: '.'
    },
    thousands: {
      type: String,
      default: '.'
    },
    precision: {
      type: Number,
      default: 0
    },
    v: {
      type: Object,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    },
    customErrorMessage: {
      type: Object,
      default: () => {}
    },
    prependOuter: {
      type: String,
      default: undefined
    },
    appendOuter: {
      type: String,
      default: undefined
    },
    hideRequired: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: 20
    },
  },
  data: () => ({
    focused: false
  }),
  computed: {
    hasError () {
      return !!this.currentError
    },
    currentError () {
      const formVuelidate = this.$formErrors(this.v)
      return Array.isArray(formVuelidate)? formVuelidate[0] : null
    },
    isRequired () {
      return this.v?.$params?.required
    },
    config () {
      return {
        decimal: this.decimal,
        thousands: this.thousands,
        prefix: this.prefix,
        suffix: this.suffix,
        precision: this.precision
      }
    }
  },
  methods: {
    input (value) {
      this.$emit('input', parseFloat(value))
    },
    blur ({ target: { value } }) {
      if (this.v) this.v.$touch()
      this.$emit('blur', parseFloat(value))
    },
    focus () {
      this.focused = true
      this.$emit('focus')
    },
    focusout () {
      this.focused = false
    }
  }
}
</script>

<style lang="stylus" scoped>
.app-number-input
  align-items flex-start
  display flex

  .append-outer,
  .prepend-outer
    margin-top 16px
    color var(--v-gray-base)

  .prepend-outer
    margin-right 8px

  .append-outer
    margin-left 8px
  .v-money:disabled
    color: rgba(0,0,0,.38) !important;

  .v-label
    left: 0px
    right: auto
    position: absolute
</style>
